<template>
<div class="qrcode">
        <div class="paytmimg" v-if="user.phone">
                <template v-if="way === 'qrcode'">
        <p class="headline">Get QR CODE</p>
        <p class="subtitle"> {{data.message}}</p>
        <v-btn class="success" flat @click="way = 'create'">Activate Now</v-btn>
    </template>
    <template v-if="way === 'create' || way === 'edit' ">
        <v-text-field solo label="Company Name/Shop Name" v-model="name" />
        <v-btn style="min-width:300px;" flat class="ml-0 primary" @click="submit()">Submit</v-btn>
    </template>
    <template v-if="way === 'qr' ">
              <img :src="url" alt />
              <div class="title mb-3">
              {{name}}
                  </div>
      <v-layout row wrap style="width:250px;margin: 0 auto">
        <v-flex xs12 sm3>
          <v-btn flat icon color="green" @click="way = 'edit'">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12 sm3>
          <v-btn flat icon color="blue" @click="download()">
            <v-icon>save</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12 sm3>
          <v-btn flat icon color="indigo" @click="copyText()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
              />
            </svg>
          </v-btn>
        </v-flex>
        <v-flex xs12 sm3>
      <social-sharing
          :url="url"
          inline-template
        >
          <div>
            <network network="whatsapp">
              <img src="../assets/whatsapp.png" style="width:35px;margin-top:5px" />
            </network>
          </div>
        </social-sharing>
</v-flex>
  
      </v-layout>
    </template>
    </div>
    <div v-else class="title" style="text-align:center">Login Required</div>

</div>
</template>
<script>

import axios from "axios";
export default {
    data() {
        return {
            way: "",
            name: "",
            data: {}
        }
    },
    computed: {
        url() {
            return 'http://chart.apis.google.com/chart?cht=qr&chs=200x200&chl='+ this.data.data.qrcode_url
        },
            user() {
            return this.$store.getters.user;
            }
    },
    methods: {
          download() {
      let vm = this;
      let url = vm.url;
      let fileName = "Download.jpg";

      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(this.response);
        var tag = document.createElement("a");
        tag.href = imageUrl;
        tag.download = fileName;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
      };
      xhr.send();
    },
    copyText() {
      let vm = this;
      let inp = document.createElement("input");
      document.body.appendChild(inp);
      let url = vm.url;
      inp.value = url;
      inp.select();
      document.execCommand("copy", false);
      inp.remove();
    },
        async submit() {
            const vm = this
            let {host} = vm.$store.getters;
            if (vm.user == null || !vm.user.phone) return vm.$root.notify("error", "Login Required!");
            if (vm.name == "") return vm.$root.notify("error","Company name required");
            let url = host +'/Admin/Services/open_qrcode.asmx/Activate_QrCode'
            if(vm.way === 'edit') {
               url = host +'/Admin/Services/open_qrcode.asmx/Update_DisplayName'
            }
            if (vm.user == null || !vm.user.phone) return vm.$root.notify("error", "Login Required!");
            let doc = {
                MobileNo: vm.user.phone,
                Password: vm.user.password,
                DisplayName: vm.name,
                AuthKey: vm.user.authkey,
                Source: "json",
            };
            try {
                vm.$root.loader = true;
                let {data} = await axios.get(url,{params: doc})
                console.log(data)
                vm.data = data;
                vm.$root.notify("success", data.message);
                vm.check();
                vm.$root.loader = false;
            }catch(err) {
                vm.$root.notify("error", err.message);
                vm.$root.loader = false;
                console.log(err.message)
            }

        },
     async check()  {
         const vm = this
         let {host} = vm.$store.getters;
        if (vm.user == null || !vm.user.phone) return vm.$root.notify("error", "Login Required!");
         let url = host +'/Admin/Services/open_qrcode.asmx/Check_QrCode'
         if (vm.user == null || !vm.user.phone) return vm.$root.notify("error", "Login Required!");
         let doc = {
             MobileNo: vm.user.phone,
             Password: vm.user.password,
             AuthKey: vm.user.authkey,
             Source: "json",
         };
         try {
            vm.$root.loader = true;
            let {data} = await axios.get(url,{params: doc})
            console.log(data)
            vm.data = data;
            if(data.status === "False") {
                vm.way = "qrcode"
            }else{
                vm.way = "qr"
                vm.name = data.data.display_name
            }
            vm.$root.loader = false;
         }catch(err) {
            vm.$root.loader = false;
            console.log(err.message)
         }
     }  
    },
    mounted() {
      let {enableGetQR} = this.$store.getters;
      if(!enableGetQR) {
        this.$router.replace('/')
        return;
      }
        this.check()
    }
}
</script>
<style>
.qrcode {
  width: 300px;
  height: 300px;
  position: absolute;
  top: 0;
  left: 0;
  text-align:center;
  right: 0;
  bottom: 0;
  margin: auto;
}
</style>

